export default "__VITE_ASSET__Ckj$qeTk__"